/* Built for MW-39, this is component attempts to generalize the wrapper
around the Google 300x250 ad that we originally built for the series page
(series#show). It will probably eventually be just one of multiple ad wrappers.

It will throw warnings if pre-rendered on the server, because the GoogleBannerAd
that it renders will render differently on the server (b/c cannot load ads
server-side).

This is intended to be (one of) our top-level entry point(s) to loading ads on
a responsive page.
*/
import "react";
import GoogleAdsStore from "../../react_stores/google_ads_store";
import GoogleBannerAd from "./google_banner_ad";

class ResponsivePageAdContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {googleAdsStore: null};
  }

  componentDidMount() {
    this.unsubscribe = GoogleAdsStore.listen((storeState) => {
      if (storeState.ads[this.props.googleBannerAd.adId]) {
        this.setState({googleAdsStore: storeState.ads[this.props.googleBannerAd.adId]});
      }
    });
  }

  componentWillUnmount() { this.unsubscribe(); }

  render() {
    // Try to only show "advertisement" label when the ad actually appears.
    return (
      <div className="responsivePageInlineAdContainer">
        {this.props.showAdvertisementLabel &&
          this.state.googleAdsStore &&
          this.state.googleAdsStore.creative &&
          <div className="responsivePageAdLabel">advertisement</div>}
        <GoogleBannerAd {...this.props.googleBannerAd} />
      </div>
    );
  }
}


ResponsivePageAdContainer.defaultProps = { showAdvertisementLabel: true };

ResponsivePageAdContainer.propTypes = {
  googleBannerAd: React.PropTypes.object.isRequired,
  showAdvertisementLabel: React.PropTypes.bool,
};

export default ResponsivePageAdContainer;
